import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NavParams } from '@ionic/angular';
//import { ModalPage } from '../modal/modal.page';

@Component({
  selector: 'app-event-info',
  templateUrl: './event-info.component.html',
  styleUrls: ['./event-info.component.scss'],
})
export class EventInfoComponent implements OnInit {
  public value = this.navParams.get('metaData');
  public selectedCatStatus = this.value.selectedBetCategory;
  public status = true;

  public country;

  @Input() metaData: any;
  @Input() event: any;
  constructor(public modalCtrl: ModalController,private navParams: NavParams) {

    //console.log("THI IS event info object data output::",this.value);
   }

  ngOnInit() {
    //console.log(this.metaData)
    //console.log(this.event);
    this.country= this.event.eventLabel;

        let re = /\((.*)\)/i;
        this.country = this.country.match(re)[1];
   
  }


  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }



}
